export const authHeaders = {
  "cf-Access-client-id": process.env.NEXT_PUBLIC_CF_ACCESS_CLIENT_ID || "",
  "cf-access-client-secret": process.env.NEXT_PUBLIC_CF_ACCESS_CLIENT_SECRET || "",
};